import React from "react";
import {FormatCurrencyWithoutSymbol} from "../../../Services/Utils";

export const formGroup = {
    id: {value: null},
    promoId: {value: "", mandatory: true},
    promoName: {value: "", mandatory: true},
    startDate: {value: null, mandatory: true},
    endDate: {value: null, mandatory: true},
    gracePeriod: {value: null, mandatory: true},
    applied: {value: "", mandatory: true},
    cabang: {value: []},
    wilayah: {value: null},
    leasingId: {value: null},
    status: {value: "ACTIVE", mandatory: true},
    promoType: {value: "", mandatory: true},
    dataUnit: {value: []},
};

export const getTableConfig = (tab) => {
    return tab === "cash" ? tableConfig.cash : tableConfig.credit
}

const tableConfig = {
    cash: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "promoId",
            label: "Promo ID",
            options: {
                sort: false,
            },
        },
        {
            name: "name",
            label: "Nama Promo",
            options: {
                sort: false,
            },
        },
        {
            name: "tanggalMulai",
            label: "Tgl Mulai",
            options: {
                sort: false,
            },
        },
        {
            name: "tanggalSelesai",
            label: "Tgl Selesai",
            options: {
                sort: false,
            },
        },
        {
            name: "gracePeriod",
            label: "Grace Period",
            options: {
                sort: false,
            },
        },
        {
            name: "berlakuDiCabang",
            label: "Berlaku di Cabang",
            options: {
                sort: false,
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (value) => {
                    return value === "ACTIVE" ? "AKTIF" : "TIDAK AKTIF"
                },
                sort: false,
            }
        },
    ],
    credit: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "promoId",
            label: "Promo ID",
            options: {
                sort: false,
            },
        },
        {
            name: "name",
            label: "Nama Promo",
            options: {
                sort: false,
            },
        },
        {
            name: "tanggalMulai",
            label: "Tgl Mulai",
            options: {
                sort: false,
            },
        },
        {
            name: "tanggalSelesai",
            label: "Tgl Selesai",
            options: {
                sort: false,
            },
        },
        {
            name: "gracePeriod",
            label: "Grace Period",
            options: {
                sort: false,
            },
        },
        {
            name: "berlakuDiCabang",
            label: "Berlaku di Cabang",
            options: {
                sort: false,
            }
        },
        {
            name: "leasing",
            label: "Leasing",
            options: {
                customBodyRender: (value) => {
                    return value || "-";
                }
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (value) => {
                    return value === "ACTIVE" ? "AKTIF" : "TIDAK AKTIF";
                }
            }
        },
    ],
};


export const getTableDetailUnitConfig = (tab) => {
    return tab === "cash" ? tableDetailUnitConfig.cash : tableDetailUnitConfig.credit
}

const tableDetailUnitConfig = {
    cash: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Kode Variant",
            options: {
                customBodyRender: (value) => {
                    return value.kodeVariant || "-";
                }
            },
        },
        {
            name: "dataVariant",
            label: "Nama Variant",
            options: {
                customBodyRender: (value) => {
                    return value.namaVariant || "-";
                }
            },
        },
        {
            name: "tahunProduksi",
            label: "Tahun Produksi",
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value.kodeWarna || "-";
                }
            },
        },
        {
            name: "dataWarna",
            label: "Nama Warna",
            options: {
                customBodyRender: (value) => {
                    return value.namaWarnaKomersil || "-";
                }
            },
        },
        {
            name: "subsidiAhm",
            label: "Subsidi AHM",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "subsidiMd",
            label: "Subsidi MD",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "subsidiDealer",
            label: "Subsidi Dealer",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "diskonMinimum",
            label: "Diskon Minimum",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel1",
            label: "Diskon Level 1",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel2",
            label: "Diskon Level 2",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel3",
            label: "Diskon Level 3",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel4",
            label: "Diskon Level 4",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel5",
            label: "Diskon Level 5",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel6",
            label: "Diskon Level 6",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel7",
            label: "Diskon Level 7",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel8",
            label: "Diskon Level 8",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
    ],
    credit: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    
                    const viewIndex = (tableMeta.rowIndex + 1) - rowsPerPage > 0 ? tableMeta.rowIndex - rowsPerPage : tableMeta.rowIndex 
                    const rowNumber = page * rowsPerPage + (viewIndex + 1);

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Kode Variant",
            options: {
                customBodyRender: (value) => {
                    return value.kodeVariant || "-";
                }
            },
        },
        {
            name: "dataVariant",
            label: "Nama Variant",
            options: {
                customBodyRender: (value) => {
                    return value.namaVariant || "-";
                }
            },
        },
        {
            name: "tahunProduksi",
            label: "Tahun Produksi",
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value.kodeWarna || "-";
                }
            },
        },
        {
            name: "dataWarna",
            label: "Nama Warna",
            options: {
                customBodyRender: (value) => {
                    return value.namaWarnaKomersil || "-";
                }
            },
        },
        {
            name: "subsidiAhm",
            label: "Subsidi AHM",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "subsidiMd",
            label: "Subsidi MD",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "subsidiDealer",
            label: "Subsidi Dealer",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "diskonMinimum",
            label: "Diskon Minimum",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
        {
            name: "nominalLevel1",
            label: "Diskon Level 1",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel2",
            label: "Diskon Level 2",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel3",
            label: "Diskon Level 3",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel4",
            label: "Diskon Level 4",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel5",
            label: "Diskon Level 5",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel6",
            label: "Diskon Level 6",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel7",
            label: "Diskon Level 7",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "nominalLevel8",
            label: "Diskon Level 8",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            }
        },
        {
            name: "dpAwal",
            label: "DP Awal",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
        {
            name: "dpAkhir",
            label: "DP Akhir",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
        {
            name: "tenorAwal",
            label: "Tenor Awal",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
        {
            name: "tenorAkhir",
            label: "Tenor Akhir",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
        {
            name: "jp1",
            label: "JP1",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
        {
            name: "jp2",
            label: "JP2",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
        {
            name: "jp3",
            label: "JP3",
            options: {
                customBodyRender: (value) => {
                    return FormatCurrencyWithoutSymbol({number: value}) || 0;
                }
            },
        },
    ],
};
